import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_SELLER_ENDED_CATALOGS_FAIL = 'la/domain/sellerEndedCatalogs/LOAD_FAIL';
export const LOAD_SELLER_ENDED_CATALOGS_REQUEST = 'la/domain/sellerEndedCatalogs/LOAD_REQUEST';
export const LOAD_SELLER_ENDED_CATALOGS_SUCCESS = 'la/domain/sellerEndedCatalogs/LOAD_SUCCESS';
export type LoadSellerEndedCatalogsSuccessAction = TypedActionWithPayload<
    typeof LOAD_SELLER_ENDED_CATALOGS_SUCCESS,
    any
>;
